import React from "react";

export default class PopularArticles extends React.Component  
{
    constructor(props)    
    {
        super(props);

        this.articles = this.props.articles;

        this.title = "Popular Articles";

        this.requestImageFile = require.context('../images/', true, /.png$/);
    }
    
    render()
    {
        return (
            <div className="container popular-articles">    
                <h2>{this.title}</h2>            
                <div className="articles">
                    <div className="row">
                    {
                        this.articles.map((article, index) =>
                        {                                                 
                            return(
                                <div key={index} className="col-lg-4">
                                    <a href={article.url} className="article">
                                        <div className="image">
                                            <img src={article.image.path} alt={article.image.alt}/>
                                        </div>
                                        <div className="text"><span>{article.title}</span></div>
                                    </a>
                                </div>
                            )
                        })
                    }
                    </div> 
                </div>
            </div>
        )
    }
};